<template>
  <ul class="content_tab" ref="categoriesTab">
    <li
      v-for="subcategory in this.initialDisplayedSubCategories"
      v-bind:class="[
        'content_tab_special-editions',
        { active: isActive(subcategory.subCategoryID) },
      ]"
      v-bind:id="subcategory.subCategoryID"
      v-bind:key="subcategory.subCategoryNumber"
    >
      <a v-on:click="clickTab(subcategory.subCategoryID)" class="pointer_bt">
        <CreateplusMessage
          fcontId="2"
          v-bind:flinkId="subcategory.subCategoryNumber.toString()"
          msgkey="1"
        />
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateplusMessage from "./CreateplusMessage";

export default {
  name: "CreatePlusTemplateListTabs",
  props: {
    categoryID: String,
    subCategoryID: String,
  },
  components: {
    CreateplusMessage,
  },
  computed: {
    ...mapState(['setupnavi', 'languageChangeCount', 'lg2']),
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),
    ...mapGetters(["isBuiltInApp"]),
    ...mapGetters('createplusTemplates', ["getSortSubCategories"]),
    
    initialDisplayedSubCategories: function() {
      return this.getSortSubCategories(this.categoryID)
    },
  },
  methods: {
    isActive: function (categoryId) {
      return this.subCategoryID == categoryId;
    },
    clickTab: function (subcategoryid) {
      this.$gtag.event("select_content", {
        "content_type": "subcategory",
        "item_category": this.categoryID,
        "item_category2": subcategoryid,
        "location_id": "create_subcategory_tab",
        "site_id": "create"
      })

      if (this.isBuiltInApp){
        this.$router.push({ 
          path: '/createplus/' + this.lg2 + '/app/templates/' + this.categoryID + '/' + subcategoryid,
          query: { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }
        })
      }else {
        this.$router.push({ 
          path: '/createplus/' + this.lg2 + '/templates/' + this.categoryID + '/' + subcategoryid,
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        })
      }
    },
  },
  mounted: function () {
    /*
    // 選択済みのカテゴリを中央に表示
    let tabElement = this.$refs.categoriesTab.firstElementChild;
    let targetElement;
    while (tabElement) {
      const categoryTitle = tabElement.getAttribute("id");
      if (categoryTitle == this.categoryTitle(this.subCategoryID)) {
        targetElement = tabElement;
        break;
      }
      tabElement = tabElement.nextElementSibling;
    }
    const leftPos =
      targetElement.getBoundingClientRect().left -
      window.innerWidth / 2.0 +
      targetElement.getBoundingClientRect().width / 2.0;
    this.$refs.categoriesTab.scrollLeft = leftPos;
    */
  },
  metaInfo() {
    return {
      link: [
        { rel: 'stylesheet', href: process.env.VUE_APP_ROOT + '/assets/createplus/css/category_tabs.css' }
      ]
    }
  } 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
